export const makeApiUrlAuthenticationLogin = (): string => {
  return '/auth/admin/signin';
};

export const makeApiUrlAuthenticationLogout = (): string => {
  return '/auth/admin/sign-out';
};

export const makeApiUrlTask = (): string => {
  return 'tasks/admin';
};

export const makeApiUrlUsers = (): string => {
  return '/admin/users';
};

export const makeApiUrlCourse = (): string => {
  return 'courses/admin';
};

export const makeApiUrlInternshipLocations = (): string => {
  return '/internship-locations/admin';
};

export const makeApiUrlInternshipResponsibleCpf = (): string => {
  return '/internship-locations/admin/verify-responsible-cpf';
};

export const makeApiUrlInternshipResponsibleEmail = (): string => {
  return '/internship-locations/admin/verify-responsible-email';
};

export const makeApiUrlInternshipLocationImage = (): string => {
  return '/admin/internship-locations/image';
};

export const makeExternalApiViaCepUrlZipCode = (): string => {
  return 'https://viacep.com.br/ws';
};

export const makeApiUrlCities = (): string => {
  return '/admin/cities';
};

export const makeApiUrlCountries = (): string => {
  return '/admin/countries';
};

export const makeApiUrlGetCoordinatesFromAddress = (): string => {
  return '/internship-locations/admin/coordinates';
};

// Dashboard
export const makeApiUrlActivityByStatus = (): string => {
  return '/activities';
};

export const makeApiUrlActivitiesByGroup = (): string => {
  return '/dashboard/admin/get-resume-activities-by-group';
};

export const makeApiUrlActivitiesByPlace = (): string => {
  return '/dashboard/admin/get-resume-activities-by-place';
};

export const makeApiUrlAllActivitiesByStatus = (): string => {
  return '/dashboard/admin/get-activities-by-status';
};

export const makeApiUrlActivitiesByStudent = (): string => {
  return '/dashboard/admin/get-resume-activities-by-student';
};

export const makeApiUrlActivitiesByTask = (): string => {
  return '/dashboard/admin/get-resume-activities-by-task';
};

export const makeApiUrlCompletedAndMissedActivitiesCount = (): string => {
  return '/dashboard/admin/completed-and-missed-activities-count';
};

export const makeApiUrlActivitiesInProgressCount = (): string => {
  return '/dashboard/admin/activities-in-progress-count';
};

export const makeApiUrlCHMetrics = (): string => {
  return '/dashboard/admin/get-workload-metrics';
};

export const makeApiUrlUsersMetrics = (): string => {
  return '/dashboard/admin/get-users-online';
};

export const makeApiUrlSummaryProfile = (): string => {
  return '/dashboard/admin/get-profile-summary';
};

export const makeApiUrlMapActivitiesMarkers = (): string => {
  return '/dashboard/admin/get-geolocations-activities-points';
};

export const makeApiUrlMapInternshipMarkers = (): string => {
  return '/dashboard/admin/get-geolocations-internship-points';
};

export const makeApiUrlMapActivityDetails = (): string => {
  return '/dashboard/admin/get-geolocation-activity-details';
};

// Group
export const makeApiUrlGroupsUser = (): string => {
  return '/groups/admin/list-user-associated';
};

// Courses
export const makeApiUrlCoursesUser = (): string => {
  return '/courses/admin/list-user-associated';
};
// Semesters
export const makeApiUrlSemestersUser = (): string => {
  return '/semesters/admin/list-user-associated';
};

// Organizations
export const makeApiUrlOrganizationsUser = (): string => {
  return '/organizations/admin/list-user-associated';
};

// Curricular Units
export const makeApiUrlCurricularUnitsUser = (): string => {
  return '/curricular-unit/admin/list-user-associated';
};

// Evaluation Criteria
export const makeApiUrlEvaluationCriteria = (): string => {
  return '/admin/criteria';
};

export const makeApiUrlEvaluationCriteriaQuestions = (): string => {
  return '/admin/criteria/questions';
};

export const makeApiUrlEvaluationCriteriaQuestionOptions = (): string => {
  return '/admin/criteria/questions/options';
};

export const makeApiUrlOnlineUsersPerOrganizationIndicators = (): string => {
  return '/admin/dashboard/online-users-by-organization';
};

export const makeApiUrlLastRegistrationApp = (): string => {
  return '/admin/dashboard/last-registered-app';
};

export const makeApiUrlUsersOnlinePlatform = (): string => {
  return '/admin/dashboard/online-users-by-platform';
};

// Entities
export const makeApiUrlEntities = (): string => {
  return '/admin/entity';
};

export const makeApiUrlEntitiesSummary = (): string => {
  return '/admin/entity?summary=true';
};

export const makeApiUrlInsureCompanies = (): string => {
  return '/admin/insurance-companies';
};

export const makeApiUrlSsoProviders = (): string => {
  return '/admin/sso-providers';
};

export const makeApiUrlEntitiesCourses = (): string => {
  return '/admin/entity-courses';
};

export const makeApiUrlEntitiesSemesters = (): string => {
  return '/admin/entity-semester';
};

export const makeApiUrlEntitiesPersons = (): string => {
  return '/admin/entity-persons';
};

export const makeApiUrlEntitiesNomenclatures = (): string => {
  return '/admin/nomenclature';
};

// Professions
export const makeApiUrlProfessions = (): string => {
  return 'professions/admin';
};

// Shifts
export const makeApiUrlShifts = (): string => {
  return '/shift/admin';
};

// Person
export const makeApiUrlPerson = (): string => {
  return '/admin/person';
};

// Fica no api-web (prefixo /web), nao no legado como o resto da edicao de pessoa
export const makeApiUrlAdminPeople = (): string => {
  return '/web/admin/people';
};

export const makeApiUrlPersonProfile = (): string => {
  return '/admin/person/profiles';
};

export const makeApiUrlCoursesByPerson = (): string => {
  return '/admin/person/courses';
};

export const makeApiUrlPersonValidatedActivities = (): string => {
  return '/admin/person/validated-activities';
};

export const makeApiUrlPersonCompletedEvaluations = (): string => {
  return '/admin/person/surveys/list';
};

export const makeApiUrlCompletedEvaluationDetails = (): string => {
  return '/admin/person/surveys/detail';
};

export const makeApiUrlCompletedEvaluations = (): string => {
  return '/admin/person/surveys';
};

export const makeApiUrlProfile = (): string => {
  return '/admin/users';
};

export const makeApiUrlUsersOnline = (): string => {
  return '/users/admin/online';
};

export const makeApiUrlUsersOnlineMaps = (): string => {
  return '/users/admin/online/distribution';
};

export const makeApiUrlPushNotification = (): string => {
  return '/notifications/push-notification/admin/filtered';
};

export const makeApiUrlSchedulePushNotification = (): string => {
  return '/notifications/push-notification/admin/schedule';
};

export const makeApiUrlScheduledPushNotificationList = (): string => {
  return '/notifications/push-notification/admin/scheduled';
};

export const makeApiUrlCancelScheduledPushNotification = (): string => {
  return '/notifications/push-notification/admin/cancel';
};

export const makeApiUrlScheduledPushNotificationGetById = (): string => {
  return '/notifications/push-notification/admin/scheduled';
};

export const makeApiUrlUpdateScheduledPushNotification = (): string => {
  return '/notifications/push-notification/admin/schedule';
};

export const makeApiUrlReschedulePushNotification = (): string => {
  return '/notifications/push-notification/admin/reschedule';
};

export const makeApiUrlRecurringPushNotification = (): string => {
  return '/notifications/push-notification/admin/recurring';
};

export const makeApiUrlCancelRecurringPushNotification = (): string => {
  return '/notifications/push-notification/admin/cancel';
};

export const makeApiUrlPauseRecurringPushNotification = (): string => {
  return '/notifications/push-notification/admin/pause';
};

export const makeApiUrlResumeRecurringPushNotification = (): string => {
  return '/notifications/push-notification/admin/resume';
};

export const makeApiUrlImpersonate = (): string => {
  return '/auth/admin/impersonate';
};

export const makeApiUrlSearchByCnpj = (): string => {
  return '/organizations/admin';
};

export const makeApiUrlActivitiesInProgressCountGroupedByOrganization =
  (): string => {
    return '/admin/dashboard/activities-in-progress-count-grouped-by-organization';
  };

export const makeApiUrlAdminEntity = (): string => {
  return '/admin/entity/';
};

export const makeApiUrlPersonActivities = (): string => {
  return '/admin/students/overview/activities';
};

export const makeApiUrlAuthenticationMe = (): string => {
  return '/auth/admin/me';
};

export const makeApiUrlBanner = (): string => {
  return '/admin/entity/banner';
};

export const makeApiUrlPhoto = (): string => {
  return '/admin/entity/photo';
};

export const makeApiUrlActivityById = (): string => {
  return '/activities/admin';
};

export const makeApiUrlDeleteActivity = (): string => {
  return '/admin/activities';
};

export const makeApiUrlDeleteActivityValidation = (): string => {
  return '/admin/activities/validation';
};

export const makeApiUrlFieldAssessments = (): string => {
  return '/admin/entity/field-assessments';
};

export const makeApiUrlLastProductVersions = (): string => {
  return '/common-utils/last-product-version';
};
// Report

export const makeApiUrlReportRadino = (): string => {
  return '/admin/reports/radinos/people-balance';
};

// reset password

export const makeApiUrlResetPasswordSendCode = (): string => {
  return '/auth/admin/password/request-reset';
};

export const makeApiUrlResetPassword = (): string => {
  return '/auth/admin/password';
};

export const makeApiUrlResetPasswordValidatedCode = (): string => {
  return '/auth/admin/2fa/validate';
};

export const makeApiUrlPartners = (): string => '/admin/partners';

export const makeApiUrlPartnerRequests = (): string =>
  '/admin/partners/requests';
export const makeApiUrlPartnerRequestById = (id: number): string =>
  `/admin/partners/requests/${id}`;
export const makeApiUrlPartnerRequestToggle = (id: number): string =>
  `/admin/partners/requests/${id}/toggle`;
export const makeApiUrlPartnerApiKey = (id: number): string =>
  `/admin/partners/${id}/api-key`;
export const makeApiUrlPartnerRequestKeyPreview = (): string =>
  '/admin/partners/requests/key-preview';

// Api Keys
export const makeApiUrlApiKeys = (): string => '/web/admin/api-keys';
export const makeApiUrlApiKeyById = (id: string): string =>
  `/web/admin/api-keys/${id}`;
export const makeApiUrlApiKeyToggle = (id: string): string =>
  `/web/admin/api-keys/${id}/toggle`;

// Sectors
export const makeApiUrlSectors = (): string => '/web/admin/sectors';
